<div class="container-fluid p-0">
  <!-- Seção de Edição em Massa -->
  @if (vendedores.length > 0 && vendedoresSelecionados.size > 0) {
    <div class="alert alert-warning p-3 mb-3">
      <div class="form-row">
        <!-- Placeholder para futuros campos de edição em massa -->
      </div>
      <div class="form-group d-flex align-items-start gap-2">
        <button class="btn btn-warning btn_formulario" type="button" (click)="aplicarEdicaoEmMassa()">
          ⚙️ Aplicar em Massa ({{ vendedoresSelecionados.size }})
        </button>
        <button class="btn btn-danger btn_formulario" type="button" (click)="removerVendedorEmMassa()">
          🗑️ Remover ({{ vendedoresSelecionados.size }})
        </button>
        <button class="btn btn-secondary btn_formulario" type="button" (click)="limparEdicaoEmMassa()">
          Limpar
        </button>
      </div>
    </div>
  }

  <!-- Tabela de Vendedores -->
  <div class="table-responsive">
    <table class="table table-sm table-hover">
      <thead>
        <tr>
          <!-- Checkbox Selecionar Todos -->
          <th class="text-center" style="width: 40px;">
            <input type="checkbox" [checked]="todosSelecionados" (change)="selecionarTodos()" />
          </th>

          <th></th>
          <th class="text-center tabela_borda">Código</th>
          <th class="tabela_borda">Vendedor(a)</th>
        </tr>
      </thead>

      <tbody>
        @for (vendedor of vendedores; track vendedor; let i = $index) {
          <tr>
            <!-- Checkbox Selecionar -->
            <td class="text-center">
              <input type="checkbox" [checked]="estaVendedorSelecionado(vendedor.idvendedor)" (change)="selecionarVendedor(vendedor.idvendedor)" />
            </td>
            <!-- Ícone de Editar -->
            <td class="text-center tabela_acao">
              <span title="Clique nas células para editar">✏️</span>
            </td>
            <!-- Código -->
            <td class="text-center tabela_borda">{{ vendedor.idvendedor }}</td>
            <!-- Vendedor(a) (Editável) -->
            <td class="tabela_borda" (click)="iniciarEdicao(i, 'fullname')" style="cursor: pointer; padding: 0.25rem;">
              <!-- Modo Visualização -->
              @if (!estaEditando(i, 'fullname')) {
                <span>
                  {{ vendedor.fullname }}
                </span>
              }
              <!-- Modo Edição -->
              @if (estaEditando(i, 'fullname')) {
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [(ngModel)]="vendedor.fullname"
                  (blur)="finalizarEdicao(i, 'fullname')"
                  (keyup.enter)="finalizarEdicao(i, 'fullname')"
                  (keyup.escape)="cancelarEdicao(i)"
                  autofocus />
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

</div>
